import type { AccessibleResourceName } from '@/types'

export const productTypes = {
  ACT: 'act',
  ACTIVITY: 'activity',
  AI_ASSISTANT: 'ai_assistant',
  APP: 'app',
  ASSESSMENT: 'assessment',
  ATTENSI: 'attensi',
  BEHAVIOR: 'behavior',
  DIALOGUE: 'dialogue',
  FAST_SURVEY: 'fast_survey',
  FAST: 'fast',
  FILE: 'file',
  HTML: 'html',
  LINK: 'link',
  MEET: 'meet',
  OPERATIONS: 'operations',
  PDF: 'pdf',
  PROCESS_ON_WEB: 'process_on_web',
  PROCESS: 'process',
  QUIZ_RACE: 'quiz_race',
  SCORM: 'scorm',
  SIM: 'sim',
  SKILL: 'skill',
  THIRDPARTY: 'third_party',
  VIDEO: 'video',
  WORKFLOW: 'workflow',
  XAPI: 'xapi',
  REAL_TALK: 'real_talk',
  REAL_TALK_MAKER: 'real_talk_maker',
  SKILLS_REAL_TALK: 'skills_real_talk',
} as const

export type ProductType = (typeof productTypes)[keyof typeof productTypes]

export type ProductTypeItem = {
  name: string
  img: string
  description: string
  identifier: string
  url: string
  requiredFeatureFlags?: string[]
  /** Superadmins skip `requiredFeatureFlags` unless this is set */
  enforceFeatureFlagsForSuperadmin?: boolean
  accessibleResource?: AccessibleResourceName
  /** Permission level `accessibleResource` must grant; defaults to `write` */
  accessibleAction?: 'write' | 'manage'
  requiredRoles?: string[]
}

// Menu identifier → backend `products_create_<type>` accessible resource name (BACKINT-229).
// The 9 real creatable types; the ATTENSI card has no create resource (visibility only).
export const PRODUCT_TYPE_CREATE_RESOURCE: Record<
  string,
  AccessibleResourceName
> = {
  [productTypes.VIDEO]: 'products_create_video',
  [productTypes.PDF]: 'products_create_pdf',
  [productTypes.FILE]: 'products_create_file',
  [productTypes.LINK]: 'products_create_link',
  [productTypes.XAPI]: 'products_create_xapi',
  [productTypes.APP]: 'products_create_app',
  [productTypes.MEET]: 'products_create_meet',
  [productTypes.ACTIVITY]: 'products_create_activity',
  [productTypes.FAST]: 'products_create_fast',
}
